// @flow
import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import "./styles.css";
import DropDown from "../drop-down";
import queryString from "query-string";

const changePageSize = Symbol("@@_CHANGE_PAGE_SIZE");

/**
 * changes the page size
 * @param {number} value - the value
 * @returns {void}
 * @private
 */
function _changePageSize(value) {
    const q = queryString.parse(window.location.search);
    const next = `${this.props.location.pathname}?${ queryString.stringify({ ...q, perPage: value, page: 1 })}`;
    this.props.history.push(next);
}

type Props = {
    currentPage: number,
    from: number,
    history: Object,
    lastPage: number,
    location: Object,
    nextPageUrl: string,
    perPage: number,
    prevPageURL: string,
    path: string,
    to: number,
    total: number
};


class _PaginationControls extends Component<Props> {

    constructor(props) {
        super(props);
        (this: any)[changePageSize] = _changePageSize.bind(this);
    }


    render() {
        const { currentPage, lastPage, total, to, from, perPage } = this.props;
        const q = queryString.parse(window.location.search);
        const nextPageNumber = Number(currentPage) === Number(lastPage) ? 1 : Number(currentPage || 1) + 1;
        const prevPageNumber = Number(currentPage) <= 1 ? 1 : Number(currentPage || 1) - 1;
        const nextLink = `${this.props.location.pathname}?${ queryString.stringify({
            ...q,
            perPage,
            page: nextPageNumber
        })}`;
        const firstLink = `${this.props.location.pathname}?${ queryString.stringify({ ...q, perPage, page: 1 })}`;
        const prevLink = `${this.props.location.pathname}?${ queryString.stringify({
            ...q,
            perPage,
            page: prevPageNumber
        })}`;
        const lastLink = `${this.props.location.pathname}?${ queryString.stringify({
            ...q,
            perPage,
            page: Number(lastPage)
        })}`;

        return (
            <nav className={ "pagination-controls" }>
                <div className={ "pagination-controls--controls" }>
                    <span className={ "pagination-controls--span" }>
                        <Link className={ "pagination-controls--link" } to={ firstLink }>{"First"}</Link>
                    </span>
                    <span className={ "pagination-controls--span" }>
                        <Link className={ "pagination-controls--link" } to={ prevLink }>{"Prev"}</Link>
                    </span>
                    <span className={ "pagination-controls--span" }>
                        <DropDown
                            onChange={ (this: any)[changePageSize] }
                            placeholder={ "page size" }
                            value={ perPage }
                        >
                            {[5, 10, 15, 25, 50, 75, 100, 200].map(num => <option key={ num } value={ num }>{num}</option>)}
                        </DropDown>
                    </span>
                    <span className={ "pagination-controls--span" }>
                        <Link className={ "pagination-controls--link" } to={ nextLink }>{"Next"}</Link>
                    </span>
                    <span className={ "pagination-controls--span" }>
                        <Link className={ "pagination-controls--link" } to={ lastLink }>{"Last"}</Link>
                    </span>
                </div>
                <div className={ "pagination-controls--current-page" }>
                    <span>{`page ${currentPage} of ${lastPage} ---- records ${from} to ${to} of ${total}`}</span>
                </div>
            </nav>
        )
        ;
    }
}


export default withRouter(_PaginationControls);
